import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "17",
      height: "17",
      x: ".5",
      y: "3.5",
      stroke: "currentColor",
      rx: "3.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.3 12.8H9.66v3.58H7.98V12.8H4.34v-1.58h3.64v-3.6h1.68v3.6h3.64z"
    }, null, -1)
  ]))]))
}
export default { render: render }